import { Wishlist } from '@ynap/api-utils';
import { ADD_TO_WISHLIST_NO_SIZE_SELECTED_ERROR, ADD_ITEM_PREFIX, views } from '../constants';
import { fetchData } from './fetchData';
import { apiAuthenticatedRequest, noUberTokenError } from '../utils/apiCall';
import { notifyWishlistChange } from '../utils/siteFurnitureAPI';
import { getCommerceConfig } from '../selectors/getConfig';
import { getWishlistState, getPdpUrlTemplate, getMessages } from '../selectors';
import { productSelectors } from '@ynap/product-state';
import { notificationActions } from '@ynap/notification-state';
const { getProductLinkByPartNumber } = productSelectors;

export default function (skuPartNumber, wishlistId = '@default', options = {}, addToWishlistLoading) {
    return (dispatch, getState) => {
        //to cover wcs perf issue
        if (addToWishlistLoading) {
            return;
        }
        const state = getState();
        const { wishlist = {}, navigation = {} } = getWishlistState(state);
        const { notifications } = getMessages(state);
        const { uniqueID, view } = wishlist;
        const { wishlistsList } = navigation;
        const { undoAction } = options;

        const wishlistToBeAdded = wishlistsList?.find((wl) => wishlistId?.toString() === wl.id);

        if ((view !== views.PUBLIC && uniqueID === wishlistId) || undoAction) {
            return dispatch(addItemToWishlist(skuPartNumber, wishlistId))
                .then(() => {
                    undoAction &&
                        dispatch(
                            notificationActions.setNotification({
                                name: 'action',
                                type: 'popup-success',
                                message: notifications.SUCCESS_UNDO_ACTION({ view, name: wishlistToBeAdded?.name }),
                            }),
                        );
                    return dispatch(fetchData(view, wishlistId, state.router.location.search, options));
                })
                .catch((error) => {
                    const errorMessage = error?.error?.errors ? error.error.errors[0]?.errorKey : '';
                    undoAction &&
                        dispatch(
                            notificationActions.setNotification({
                                name: 'action',
                                type: 'popup-error',
                                message: notifications.errors({ error: errorMessage }),
                            }),
                        );
                });
        } else {
            return dispatch(addItemToWishlist(skuPartNumber, wishlistId));
        }
    };
}

function addItemToWishlist(skuPartNumber, wishlistId) {
    return (dispatch, getState) => {
        const state = getState();
        const { baseUrl, brandId, clientId, country, language, locale, uberToken } = getCommerceConfig(state);
        const productUrl = skuPartNumber && getProductLinkByPartNumber(getPdpUrlTemplate(state), locale, undefined, skuPartNumber);
        const redirectToLoginParams = productUrl ? { redirect: `${productUrl}?mode=addToWishlist` } : {};

        if (!skuPartNumber) {
            dispatch({ type: ADD_TO_WISHLIST_NO_SIZE_SELECTED_ERROR });
            return;
        }

        if (!uberToken) {
            return dispatch(noUberTokenError(uberToken, ADD_ITEM_PREFIX, locale, redirectToLoginParams));
        }

        return dispatch(
            apiAuthenticatedRequest(
                Wishlist.addItems({
                    items: [{ partNumber: skuPartNumber }],
                    uberToken,
                    baseUrl,
                    brandId,
                    country,
                    language,
                    quantity: 1,
                    clientId,
                    wishlistId,
                }),
                ADD_ITEM_PREFIX,
                locale,
                {
                    errorTags: ['fetchWishlistsError'],
                    bypassCreateGuestUbertoken: true,
                    redirectToLoginParams,
                },
            ),
        )
            .then(notifyWishlistChange)
            .catch((error) => {
                throw error;
            });
    };
}
